<template>
    <div class="global-content">
        <div class="info-box">
            <a-config-provider :locale="zhCN">
                <a-table
                    :dataSource="data"
                    :columns="columns"
                    :pagination="pagination"
                    :bordered="bordered"
                    :rowKey="(record, index) => index"
                >
                    <div
                        slot="filterDropdown"
                        slot-scope="{
                            setSelectedKeys,
                            selectedKeys,
                            confirm,
                            clearFilters,
                            column,
                        }"
                        style="padding: 8px"
                    >
                        <a-input
                            v-ant-ref="(c) => (searchInput = c)"
                            :placeholder="`Search ${column.dataIndex}`"
                            :value="selectedKeys[0]"
                            @change="(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                            @pressEnter="() => handleSearch(selectedKeys, confirm)"
                            style="width: 188px; margin-bottom: 8px; display: block"
                        />
                        <a-button
                            type="primary"
                            @click="() => handleSearch(selectedKeys, confirm)"
                            icon="search"
                            size="small"
                            style="width: 90px; margin-right: 8px"
                            >Search
                        </a-button>
                        <a-button
                            @click="() => handleReset(clearFilters)"
                            size="small"
                            style="width: 90px"
                            >Reset
                        </a-button>
                    </div>
                    <a-icon
                        slot="filterIcon"
                        slot-scope="filtered"
                        type="search"
                        :style="{ color: filtered ? '#108ee9' : undefined }"
                    />
                    <template slot="customRender" slot-scope="text">
                        <span v-if="searchText">
                            <template
                                v-for="fragment in text
                                    .toString()
                                    .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))"
                            >
                                <mark
                                    v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                                    :key="fragment"
                                    class="highlight"
                                    >{{ fragment }}</mark
                                >
                                <template v-else>{{ fragment }}</template>
                            </template>
                        </span>
                        <template v-else>{{ text }} </template>
                    </template>
                    <template slot="operate" slot-scope="text, record">
                        <div v-if="record.status == 1">
                            <a-button
                                type="primary"
                                icon="eye"
                                @click="lookOverDetail(record)"
                                :size="buttonSize"
                                >查看</a-button
                            >
                            <a-button
                                :disabled="record.level == 0"
                                type="primary"
                                icon="download"
                                @click="downloadReport(record)"
                                class="my-btn"
                                :size="buttonSize"
                                :class="{
                                    lock: $lock,
                                }"
                                >下载</a-button
                            >
                            <a-button
                                type="danger"
                                icon="delete"
                                @click="deleteInfo(record.surveyId)"
                                class="my-btn"
                                :size="buttonSize"
                                >删除</a-button
                            >
                        </div>
                        <!-- <div v-else> // 3.21注释掉'继续答题'
              <a-button type="primary" icon="form" @click="continueAnswer(record)" :size="buttonSize">继续答题</a-button>
              <a-button type="danger" icon="delete" @click="deleteInfo(record.surveyId)" class="my-btn" :size="buttonSize">删除</a-button>
            </div> -->
                    </template>
                    <template slot="riskLevel" slot-scope="text">
                        <!--<a-rate :defaultValue="text" :disabled="disabled"/>-->
                        <div v-if="parseInt(text) > 0">
                            <span v-for="count in parseInt(text)" :key="count + Math.random()">
                                <img
                                    style="width: 18px; margin-left: 5px"
                                    src="../../../static/images/star-yellow.png"
                                    alt=""
                                />
                            </span>
                            <span v-for="count in 5 - parseInt(text)" :key="count + Math.random()">
                                <img
                                    style="width: 18px; margin-left: 5px"
                                    src="../../../static/images/star-grey.png"
                                    alt=""
                                />
                            </span>
                        </div>
                        <div v-else>无风险</div>
                    </template>
                    <template slot="progress" slot-scope="record">
                        {{ record }} - {{ record.moduleCompletedNumber }}
                    </template>
                </a-table>
            </a-config-provider>
        </div>
    </div>
</template>

<script>
    import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN' // 汉化
    import { downLoadPDF } from '@/utils/downloadFile/downLoadPDF'

    import { apiListPC } from '@/api'
    import ajax from '@/api/ajax'

    export default {
        name: 'Record',
        data() {
            return {
                visible: false,
                bordered: true,
                maskClosable: false, //点击遮罩层是否关闭对话框
                form: this.$form.createForm(this),
                zhCN,
                buttonSize: 'small',
                data: [],
                searchText: '',
                searchInput: null,
                pageNo: 1,
                pageSize: 10,
                pagination: {
                    showQuickJumper: true, //是否可以快速跳转至某页
                    defaultPageSize: 10, //默认每页条数
                    pageSizeOptions: ['10', '20', '50'],
                    showSizeChanger: true,
                    current: 1,
                    onShowSizeChange: (current, pageSize) => this.ChangePageSize(current, pageSize), // 改变每页数量时更新显示
                    onChange: (page, pageSize) => this.changePage(page, pageSize), //点击页码事件
                    total: 0,
                    showTotal: showTotalFunc,
                },
                columns: [
                    {
                        title: '报告名称',
                        dataIndex: 'surveyName',
                        key: 'surveyName',
                        scopedSlots: {
                            customRender: 'customRender',
                        },
                        onFilter: (value, record) =>
                            record.surveyName.toLowerCase().includes(value.toLowerCase()),
                        onFilterDropdownVisibleChange: (visible) => {
                            if (visible) {
                                setTimeout(() => {
                                    this.searchInput.focus()
                                }, 0)
                            }
                        },
                    },
                    {
                        title: '风险等级',
                        dataIndex: 'level',
                        key: 'level',
                        scopedSlots: {
                            customRender: 'riskLevel',
                        },
                        onFilter: (value, record) =>
                            record.level.toLowerCase().includes(value.toLowerCase()),
                        onFilterDropdownVisibleChange: (visible) => {
                            if (visible) {
                                setTimeout(() => {
                                    this.searchInput.focus()
                                })
                            }
                        },
                    },
                    {
                        title: '创建时间',
                        dataIndex: 'createTime',
                        key: 'createTime',
                        scopedSlots: {
                            customRender: 'customRender',
                        },
                        customRender: function (text, record) {
                            if (!record.level) {
                                // console.log(record, 'record')
                                return '未完成'
                            } else {
                                return text
                            }
                        },
                        onFilter: (value, record) =>
                            record.updateTime.toLowerCase().includes(value.toLowerCase()),
                        onFilterDropdownVisibleChange: (visible) => {
                            if (visible) {
                                setTimeout(() => {
                                    this.searchInput.focus()
                                })
                            }
                        },
                    },

                    {
                        title: '操作',
                        dataIndex: 'operate',
                        key: 'operate',
                        scopedSlots: {
                            customRender: 'operate',
                        },
                    },
                ],
            }
        },
        beforeMount() {
            let formData = new FormData()
            formData.append('pageNo', this.pageNo)
            formData.append('pageSize', this.pagination.defaultPageSize)
            getRecordListPge(this, formData)
        },
        methods: {
            ChangePageSize(current, pageSize) {
                this.pageSize = pageSize
                let formData = new FormData()
                formData.append('pageNo', 1)
                formData.append('pageSize', pageSize)
                getRecordListPge(this, formData)
            },
            changePage(page, pageSize) {
                this.searchData(page, pageSize)
            },
            searchData(page, pageSize) {
                let that = this
                //记录当前的页数
                that.pageNo = page
                let formData = new FormData()
                formData.append('pageNo', page)
                formData.append('pageSize', pageSize)
                getRecordListPge(that, formData)
            },
            handleSearch(selectedKeys, confirm) {
                confirm()
                this.searchText = selectedKeys[0]
            },

            handleReset(clearFilters) {
                clearFilters()
                this.searchText = ''
            },
            lookOverDetail({ surveyId, enterpriseId }) {
                this.$router.push({
                    path: '/Report',
                    query: {
                        surveyId,
                        enterpriseId,
                        license: this.$route.query.license || sessionStorage.getItem('license'),
                    },
                })
            },
            async downloadReport({ surveyId, enterpriseId, surveyName }) {
                downLoadPDF.call(this, surveyId, enterpriseId, surveyName)
            },

            continueAnswer({ surveyId, enterpriseId }) {
                sessionStorage.setItem('surveyId', surveyId)
                sessionStorage.setItem('enterpriseId', enterpriseId)
                ajax(apiListPC.getTeamWorkModuleFromReport, { surveyId }).then((res) => {
                    const incompleteModule = res
                        .filter((item) => item.checkStatus == '0')
                        .map((i) => i.moduleId)
                    sessionStorage.setItem('modules', incompleteModule)
                    this.$router.push('/Question')
                })
            },
            deleteInfo(surveyId) {
                let that = this
                this.$confirm({
                    content: '确认删除此条记录吗',
                    title: '提示',
                    okText: '确定',
                    cancelText: '取消',
                    type: 'error',
                    onOk() {
                        that.bus.$emit('loading', true)
                        let res = ajax(apiListPC.deleteSurvey, { surveyId })
                        res.then(function () {
                            that.bus.$emit('loading', false)
                            //删除成功以后 刷新table
                            let formData = new FormData()
                            formData.append('pageNo', that.pageNo)
                            formData.append('pageSize', that.pagination.defaultPageSize)
                            getRecordListPge(that, formData)
                        }).catch(function () {
                            that.bus.$emit('loading', false)
                        })
                    },
                })
            },
            handleOk() {
                return
            },
        },
    }
    function showTotalFunc(total, range) {
        return `总数据为${total}条，当前显示第${range[0]}条到第${range[1]}条`
    }
    function getRecordListPge(that, formData) {
        that.bus.$emit('loading', true)
        ajax(apiListPC.listSurvey).then((data) => {
            that.bus.$emit('loading', false)
            that.data = data
            that.pagination.total = data.length
            that.pagination.current = that.pageNo
            const hasServey = data.some((i) => i.surveyId == sessionStorage.getItem('surveyId'))
            if (!hasServey) {
                sessionStorage.setItem('surveyId', '')
            }
        })
    }
</script>

<style lang="less" type="text/less" scoped>
    .global-content {
        padding-top: 1px;
        .info-box {
            margin: 20px;
            min-height: 760px;
            .my-btn {
                margin-left: 10px;
            }
        }
    }

    .lock {
        background-color: #ccc;
        border-color: #ccc;
    }
</style>
